module.exports = __webpack_public_path__ + "static/img/22.5868c80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/22.png
// module id = 65ML
// module chunks = 1